import Vue from 'vue';
import App from './App.vue';
import menu from './plugins/menu.js';
import cookies from 'js-cookie';
import echarts from 'echarts';
import VueECharts from 'vue-echarts'
import router from './plugins/router';
import axios from './plugins/request';
import './plugins/style.js';//全局样式
import './plugins/func.js';//全局方法
import './plugins/tool.js';//全局组件
import './style/config.css';
import './style/theme/index.css';
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$menu = menu;
Vue.prototype.$cookie = cookies;
Vue.prototype.$echarts = echarts;
Vue.prototype.$dic = { all: {} };
Vue.prototype.$main = true;
new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
Vue.use(VueECharts);
Vue.component('v-chart', VueECharts);
Vue.prototype.$startPath = "/TourOpinion";
